'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
const KeyboardUtil = require('../../util/keyboard');
const uuid = require('uuid');

const ProjectActions = require('../../actions/ProjectActions');
const ProjectStore = require('../../stores/ProjectStore');
const ForgeError = require('../../util/error');
import ErrorBox from '../common/ErrorBox';
import TagEditorList from '../Tags/TagEditorList';
import TagEditorTable from '../Tags/TagEditorTable';
import TagHelp from '../Tags/TagHelp';
import WithOrganizationIntegrationTags from '../DataHOCs/WithOrganizationIntegrationTags';

const propTypes = {
    closeHandler: PropTypes.func.isRequired,
    show: PropTypes.bool,
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

const defaultProps = {
    show: false
};

class ManageProjectTagsModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            addActionId: null,
            projectStoreState: ProjectStore.getState()
        };

        this.onNewTagsAdd = this.onNewTagsAdd.bind(this);
        this.onDeleteTag = this.onDeleteTag.bind(this);
        this.getActiveTagExportHref = this.getActiveTagExportHref.bind(this);

        this.unsubscribes = [ProjectStore.listen(this.onProjectStoreChange.bind(this))];
    }

    UNSAFE_componentWillMount() {
        // if (!this.state.projectStoreState.projectTags[this.props.projectId]) {} //Load only if never received?
        ProjectActions.getProjectTags(uuid.v4(), { projectID: this.props.projectId });
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onProjectStoreChange(newState) {
        let additionalState = {};

        if (newState.action.id === this.state.addActionId) {
            if (!newState.action.error) {
                additionalState = { ...additionalState, addActionId: null, error: null, newTag: '' };

            }
            else {
                additionalState = { ...additionalState, addActionId: null, error: newState.action.error };
            }
        }

        this.setState({ projectStoreState: newState, ...additionalState });
    }

    onNewTagsAdd(tagRecords) {
        if (!tagRecords) {
            this.setState({ error: new ForgeError({ message: 'The tag field cannot be blank' }) });
            return;
        }

        const actionId = uuid.v4();
        this.setState({ addActionId: actionId }, () => {
            ProjectActions.addProjectTags(actionId, { projectID: this.props.projectId, tagRecords: tagRecords });
        });
    }

    onDeleteTag(tagRecord) {
        ProjectActions.deleteProjectTag(uuid.v4(), { projectID: this.props.projectId, tagRecord: tagRecord });
    }

    getActiveTagExportHref() {
        return `/authoring/projects/${this.props.projectId}/tag_v2/csv`;
    }

    render() {
        const self = this;
        const projectTags = this.state.projectStoreState.projectTags[this.props.projectId] || [];

        return (
            <Modal
                className='single-input-modal'
                show={this.props.show}
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>manage project integration tags</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ErrorBox error={this.state.error}/>
                    <TagEditorTable
                        className="padding-lr-md margin-bottom-15"
                        orgIntegrationTags={this.props.orgIntegrationTags}
                        forceRefresh
                        tags={projectTags}
                        onDeleteTag={this.onDeleteTag}
                        onNewTagsAdd={this.onNewTagsAdd}
                        pendingAddNewTag={!!this.state.addActionId}
                        activeTagExportHref={this.getActiveTagExportHref()}
                    />
                    <TagHelp className="padding-all-md" />
                </Modal.Body>
            </Modal>
        );
    }
}

ManageProjectTagsModal.propTypes = propTypes;
ManageProjectTagsModal.defaultProps = defaultProps;

export default WithOrganizationIntegrationTags(ManageProjectTagsModal);